import apiFetch from '../apiFetch'

export default function (token, signatureConfig) {
  return apiFetch({ endPoint: 'SignDocumentConfiguration', method: 'POST', body: signatureConfig, token: token })
}
